import api from '@/utils/api';

/**
 * Register user require {email, password}
 * @param {string} userId - The user id
 * @param {object} userData - The user data
 * @property {string} userData.email - The email of the user
 * @property {string} userData.password - The password of the user
 * @returns {Promise}
 */
const registerUserApi = (userId, userData) =>
  api.patch(`auth/register/${userId}`, userData);

export default registerUserApi;
